import { getPortalContent, preparePortalParams } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalServiceContentDto } from '@nx-frontend/shared/types';

interface GetPortalMenuParams {
  host: string;
  portalId: string;
  userId: number;
}

export async function getPortalMenu(params: GetPortalMenuParams): Promise<PortalServiceContentDto | null> {
  let content: PortalServiceContentDto | null = null;

  try {
    const portalParams = preparePortalParams(params);
    content = await getPortalContent({
      host: generalEnv.portalServiceUrl,
      path: undefined,
      superSecret: generalEnv.superSecret,
      userId: params.userId,
      permissionsMode: 'admin',
      cacheStrategy: 'use',
      ...portalParams,
    });
  } catch (err) {
    console.error(`getPortalMenu error: ${err}`);
  }

  return content;
}
